// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { ContrastFunction } from './contrast-function';
import { ImageOrientation } from './image-orientation';


export class Image {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Image {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsImage(bb:flatbuffers.ByteBuffer, obj?:Image):Image {
  return (obj || new Image()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsImage(bb:flatbuffers.ByteBuffer, obj?:Image):Image {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Image()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

orientation(obj?:ImageOrientation):ImageOrientation|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ImageOrientation()).__init(this.bb_pos + offset, this.bb!) : null;
}

contrast(obj?:ContrastFunction):ContrastFunction|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new ContrastFunction()).__init(this.bb_pos + offset, this.bb!) : null;
}

static startImage(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, labelOffset, 0);
}

static addOrientation(builder:flatbuffers.Builder, orientationOffset:flatbuffers.Offset) {
  builder.addFieldStruct(2, orientationOffset, 0);
}

static addContrast(builder:flatbuffers.Builder, contrastOffset:flatbuffers.Offset) {
  builder.addFieldStruct(3, contrastOffset, 0);
}

static endImage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
